import styled from 'styled-components';

export const CalendarContainer = styled.div`
	max-width: 800px;
	margin: 0 auto;

`;

export const MonthHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;

	margin-top: 20px; 
`;

export const MonthTitle = styled.h2`
	color: #2c3e50;
	margin: 0;
`;

export const ArrowButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	font-size: 1.5rem;
	color: #2c3e50;
	padding: 0 10px;
	transition: color 0.2s ease;

	&:hover {
		color: #1a73e8;
	}

	&:disabled {
		color: #ccc;
		cursor: not-allowed;
	}
`;

export const WeekDays = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 4px;
	margin-bottom: 20px; 
`;

export const WeekDay = styled.div`
	text-align: center;
	font-weight: bold;
	color: #666;
`;

export const DaysGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 4px;
`;

interface DayProps {
	$isUnavailable: boolean;
}

export const Day = styled.div<DayProps>`
	padding: 12px;
	text-align: center;
	border-radius: 4px;
	background: ${({ $isUnavailable }) =>
		$isUnavailable ? '#ffebee' : '#fff'};
	color: ${({ $isUnavailable }) => ($isUnavailable ? '#c62828' : '#2c3e50')};
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: ${({ $isUnavailable }) =>
		$isUnavailable ? '#ffcdd2' : '#f5f5f5'};
	}
`;
